<template>
  <div class="mentions_legales">
    <div id="head-page" class="contact parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/cloud.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class="" src="@/assets/images/head/echelle.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/papillon.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-8 medium-offset-2 cell content-page">

          <title-page attrpage="Mentions légales" baseline='"Informations légales"'>Globulo Quest</title-page>

          <p>
          <strong>Globulo Quest</strong> est une initiative bénévole de la Fédération Leucémie Espoir (FLE). </br>
         <strong>Statut FLE :</strong> association déclarée d’utilité publique. </br>
          <strong>Siège social FLE :</strong> 23 rue de Versailles Beaupréau, 49600 BEAUPREAU-EN-MAUGES</br>
          <strong>Siret FLE :</strong> 347 676 850 00022</br>
          <strong>Responsable de la publication FLE :</strong> Françoise Tillier, contact@leucemie-espoir.org</br>
          </p>
          <hr>
          <p>
          Le contenu de ce site web est géré par <strong>l’Antenne Leucémie Espoir Paris 20.</strong></br>
          <strong>Siège social Antenne LE Paris 20 :</strong> 37 rue Julien Lacroix 75020 PARIS</br>
          <strong>Responsable de rédaction/publication Globulo Quest :</strong> Aurélie Scheer-Danton, contact@globulo-quest.org </br>
          </p>
          <hr>
          <p>
          Ce site a été développé par l’agence web <strong>Dezup.</strong></br>
          <strong>Statut Dezup :</strong> SARL au capital de 8000€</br>
          <strong>Siège social Dezup :</strong> 8 rue Joseph Cugnot - CS 92004, 38307 BOURGOIN JALLIEU</br>
          <strong>Siret Dezup :</strong> 53349618800020</br>
          <strong>RCS Dezup :</strong> Vienne B 533 496 188</br>
          </p>
          <hr>
          <p>
          Ce site est hébergé chez <strong>OVH</strong>.</br>
          <strong>Statut OVH :</strong> SAS au capital de 10 069 020 €</br>
          <strong>Siège social OVH :</strong> 2 rue Kellermann BP 80157 59100 ROUBAIX</br>
          <strong>Siret OVH :</strong> 42476141900045</br>
          <strong>RCS OVH :</strong> Lille Métropole 424 761 419 </br>
          </p>
          <hr>
          <p>
          <strong>Protection des données :</strong>
          </br>
          Les données nominatives enregistrées sur ce site seront stockées et utilisées conformément à la loi 78-17 du 6 janvier 1978 dite " informatique et libertés ". Vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données vous concernant. Vous avez la possibilité d'exercer ce droit sur simple demande par courrier à adresse postale et adresse mail
          </p>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import BoxContribuer from '@/components/sidebar/BoxContribuer'
  export default {
    components: { TitlePage, BoxContribuer },
  }
</script>
